import { Outlet } from "react-router-dom";
import Navbar from "../pages/mainPages/Navbar";
import Sidebar from "../pages/mainPages/sidebar";
import useSidebar from "../hooks/post/useSidebar";
import { CgClose } from "react-icons/cg";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import Popup from "../modals/post/PopupMessage";
import ViewYTVideo from "../modals/ViewYTVideos";
import DeleteModal from "../modals/DeleteModal";

const PostLayout = () => {
  const { isOpen: isSidebarOpen, toggle } = useSidebar(); 

  return (
    <div className="flex flex-col h-screen">
      <Navbar />

      <div className="flex flex-1 overflow-hidden">
        <div className={`md:w-56 overflow-y-auto ${isSidebarOpen ? "block" : "hidden"} md:block`}>
          <Sidebar />
        </div>


        <div className="flex-1 p-2 overflow-y-auto">
          <Popup  />
          <Outlet />
        </div>

        <button
          onClick={toggle}
          aria-label={isSidebarOpen ? "Close sidebar" : "Open sidebar"}
          className="md:hidden fixed bottom-4 rtl:left-5 ltr:right-5 z-50"
        >
          {/* Spinner ring + button core */}
          <span className="relative inline-grid place-items-center rounded-full">
            {/* Spinning red arc (only shows on the border via mask) */}
            <span
              aria-hidden="true"
              className="
                absolute inset-0 rounded-full
                bg-[conic-gradient(from_0deg,transparent_0_82%,rgb(239_68_68)_86%_96%,transparent_100%)]
                [mask:radial-gradient(farthest-side,transparent_calc(100%-3px),#000_0)]
                animate-[spin_2.8s_linear_infinite]
                opacity-75
              "
            />
            {/* Slight glow blur that trails the arc (very light) */}
            <span
              aria-hidden="true"
              className="
                absolute inset-0 rounded-full blur
                bg-[conic-gradient(from_0deg,transparent_0_82%,rgb(239_68_68)_86%_96%,transparent_100%)]
                [mask:radial-gradient(farthest-side,transparent_calc(100%-3px),#000_0)]
                animate-[spin_2.8s_linear_infinite]
                opacity-30
              "
            />
            {/* Actual clickable button surface */}
            <span
              className="
                relative z-10 p-3 rounded-full
                bg-black/30 hover:bg-black/50 text-white backdrop-blur-sm
                transition duration-300
              "
            >
              {isSidebarOpen ? (
                <CgClose className="w-7 h-auto" />
              ) : (
                <HiOutlineMenuAlt1 className="w-7 h-auto" />
              )}
            </span>
          </span>
        </button>
          
        <ViewYTVideo />
        <DeleteModal />
        
      </div>
    </div>
  );
};

export default PostLayout;